import { useEffect } from 'react';
import { useLocalizationContext } from '@im/react-localization';

export function useHtmlLang() {
  const { locale } = useLocalizationContext();

  useEffect(() => {
    document.documentElement.lang = getLanguageFromLocale(locale);
  }, [locale]);
}

function getLanguageFromLocale(locale: string) {
  return locale.split('-')[0];
}
